import { Descriptions } from 'element-ui'

const YDescriptions = Descriptions
YDescriptions.$depends = [Descriptions]
YDescriptions.$name = 'y-descriptions'
YDescriptions._name = 'Descriptions 描述列表'

export default YDescriptions
